$(document).ready(function () {
	var
		ua = navigator.userAgent.toLowerCase(),
		event = (ua.match(/Android/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || ua.match(/iPhone/i)) ? "touchstart" : "click",
		isMobile = ua.match(/(iphone|ipod|ipad|android)/),
		window_w = $(window).width(),
		window_h = $(window).height(),
		is_home = $('body').hasClass('homepage');

	$.blockUI.defaults.message = LANG.aguarde;

	$('html').removeClass('no-js');

	if (("standalone" in window.navigator) && window.navigator.standalone) {
		$('html').addClass('ios-standalone');
	}

	if ($.browser.msie) {
		$('html').addClass('is-ie');
		$('html').addClass('ie-' + $.browser.versionNumber);
	}

	if ($.browser.msedge) {
		$('html').addClass('is-edge');
	}

	if ($.browser.iphone && $.browser.safari) {
		$('html').addClass('ios-safari');
	}

	if ($.browser.iphone && $.browser.chrome) {
		$('html').addClass('ios-chrome');
	}

	if ($.browser.android && $.browser.chrome) {
		$('html').addClass('android-chrome');
	}

	/**
	 * ScrollSmoother
	 */
	if (!Modernizr.touchevents) {
		var smoother = ScrollSmoother.create({
			smooth: 0.5,
			effects: true,
			smoothTouch: 0.1
		});
	}

	/**
	 * Embed responsive
	 */
	var iframe = $('.text iframe');
	if (iframe.length) {
		iframe.wrap("<div class='embed'></div>");
	}

	var logo_wrapper = document.getElementById('logo_ani');
	let animation = lottie.loadAnimation({
		container: logo_wrapper, // Required
		path: 'imagens/lottie/logo_anim_2024.json?r=1', // Required
		animType: 'svg',
		loop: false,
		prerender: true,
		autoplay: false,
	});

	const ScrollLottie = (obj) => {

		let anim = lottie.loadAnimation({
			container: document.querySelector(obj.target),
			renderer: 'svg',
			prerender: true,
			progressiveLoad: true,
			loop: false,
			autoplay: false,
			path: obj.path
		});

		let timeObj = { currentFrame: 0 }
		let endString = (obj.speed === "slow") ? "+=2000" : (obj.speed === "medium") ? "+=1000" : (obj.speed === undefined) ? "+=1250" : "+=500";
		ScrollTrigger.create({
			trigger: obj.target,
			scrub: true,
			pin: true,
			start: "top top",
			end: endString,
			onUpdate: self => {
				if (obj.duration) {
					gsap.to(timeObj, {
						duration: obj.duration,
						currentFrame: (Math.floor(self.progress * (anim.totalFrames - 1))),
						onUpdate: () => {
							anim.goToAndStop(timeObj.currentFrame, true)
						},
						ease: 'expo'
					})
				} else {
					anim.goToAndStop(self.progress * (anim.totalFrames - 1), true)
				}
			}
		});

	}

	if ($('#bridge-ani').length) {

		var bridgeImage = new Image();

		bridgeImage.onload = function () {
			ScrollLottie({
				target: '#bridge-ani',
				path: 'imagens/lottie/bridge_anim_2.json?r=4',
				duration: 1,
				speed: 'medium'
			});

			setTimeout(() => {
				$(window).trigger('resize');
			}, 500);
		};

		bridgeImage.src = 'imagens/lottie/bridge3.png';
	}


	/* var logo_wrapper1 = document.getElementById('bridge-ani');
	let animation1 = lottie.loadAnimation({
		container: logo_wrapper1, // Required
		path: 'imagens/lottie/bridge_anim_2.json', // Required
		animType: 'svg',
		loop: false,
		prerender: true,
		autoplay: false,
		progressiveLoad: true,
	});
	animation1.setSpeed(0.2);

	function handleIntersection(entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				// Play the Lottie animation
				animation1.play();
				observer.unobserve(entry.target); // Unobserve to avoid multiple triggers
			}
		});
	}
	const observer = new IntersectionObserver(handleIntersection, {
		threshold: 0.1 // Triggers when 50% of the target is visible
	}); 
	if ($('.we-are-section-inner').length) {
		observer.observe($('.we-are-section-inner')[0]);
	} */

	function handleDotIntersection(entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.querySelector('.checkmark').classList.add('visible');
				// observer.unobserve(entry.target); // Unobserve to avoid multiple triggers
			}
		});
	}
	const observerDot = new IntersectionObserver(handleDotIntersection, {
		threshold: 0.5 // Triggers when 50% of the target is visible
	});
	if ($('.dots').length) {
		$('.dots').each(function (index) {
			// $(this).find('.checkmark').attr('data-delay',index * 2);
			// $(this).find('.checkmark').css({'transition' : 'opacity '+index+'s ease-in-out'})
			observerDot.observe($(this)[0]);
		});

	}

	$(window).on("scroll", function () {
		if (parseInt($(window).scrollTop()) >= 45 && !$("body").hasClass("scrolled")) {
			$("body").addClass("scrolled");
			animation.setDirection(1);
			animation.play();
			//console.log(animation.getDuration(true))
			//animation.goToAndStop(14, true)
			/* animation.onComplete() = function(){
				animation.goToAndStop(14, true);
			} */
		} else if (parseInt($(window).scrollTop()) < 45 && $("body").hasClass("scrolled")) {
			$("body").removeClass("scrolled");
			animation.setDirection(-1); // Reverse the animation
			animation.play();

		}
	});
	$(window).trigger("scroll");
	/* animation.addEventListener('complete', function() {
		animation.goToAndStop(14, true);
	}); */
	/**
	 * Trigger AOS
	 */
	setTimeout(function () {

		AOS.init({
			'offset': -50,
			disable: 'mobile'
		});
	}, 300);

	setTimeout(function () {
		gsap.to('.loading-container', {
			duration: 0.3,
			ease: 'power1',
			opacity: 0,
			onComplete: function () {
				$('.loading-container').remove();
			}
		});

		if (!$.cookie('loading')) {
			$.cookie('loading', true, {
				expires: 1
			});
		}
	}, 1500);

	/**
	 * Fade loading images
	 */
	/*var load_images_bg = $('body').find('.load-img:not(.loaded), .load-img-uncover:not(.loaded)');
	if (load_images_bg.length) {
		load_images_bg.each(function (index, element) {
			var image = new Image(),
				$element = $(element),
				is_bg_or_img = typeof $element.data('src') !== 'undefined';

			image.onload = function () {
				if (is_bg_or_img) {
					$element.css("backgroundImage", "url('" + $element.attr("data-src") + "')").removeAttr('data-src');
				}
				setTimeout(function () {
					$element.parent().removeClass('loading');
					$element.addClass('loaded');
				}, 200);
			};
			image.src = is_bg_or_img ? $element.attr("data-src") : $element.find('img').attr('src');
		});
	}*/

	/**
	 * Lazy load images
	 */
	var velcroLazy = {
		/**
		 * init
		 * correr on load e sempre que for necessário, por exemplo, a seguir a uma call ajax
		 * elements: passar class dos ementos a fazer lazy load (ex: .lazy)
		 * ex: velcroLazy.init('.lazy');
		 */
		init: (elements) => {
			let lazyImages = $(elements);

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							var lazyImage = $(entry.target),
								image = lazyImage.find('img')[0] || new Image(),
								is_bg_or_img = typeof lazyImage.data('src') !== 'undefined';

							image.onload = function () {
								if (is_bg_or_img) { //is bg
									lazyImage.css("backgroundImage", "url('" + lazyImage.data("src") + "')").removeAttr('data-src');
								}
								setTimeout(function () {
									lazyImage.parent().addClass('loaded');
									lazyImage.addClass('loaded').removeClass("lazy").parent().removeClass('loading');
								}, 200);
							};

							image.src = is_bg_or_img ? lazyImage.data("src") : lazyImage.find('img').attr('data-src');
							lazyImageObserver.unobserve(entry.target);
						}
					});
				});

				lazyImages.each(function () {
					lazyImageObserver.observe(this);
				});
			} else {
				lazyImages.each(function () {
					var is_bg_or_img = typeof $(this).data('src') !== 'undefined';
					if (is_bg_or_img) { //is bg
						$(this).css("backgroundImage", "url('" + $(this).data("src") + "')").removeAttr('data-src');
					} else { //is img
						$(this).find('img').attr("src", $(this).find('img').data("src")).removeAttr('data-src');
					}
					$(this).addClass('loaded').removeClass("lazy").parent().removeClass('loading');
				});
			}
		}
	}

	velcroLazy.init('.lazy');

	var root = $('html,body');

	function smoothScrollingTo(target, extraTop = 0) {
		var target = $(target);
		const isMobile = document.body.clientWidth < 768;

		if (target.length) {
			root.animate({
				scrollTop: target.offset().top - (isMobile ? 100 : 0) + extraTop
			}, 400, "swing");
		}
	}

	$('a[href*=\\#]:not([href=\\#],[data-toggle],.open-popup)').on('click', function (event) {
		event.preventDefault();
		if (!is_home) {
			if (window.location.href != this.href) {
				smoothScrollingTo(this.hash, -80);
			}
		} else {
			event.preventDefault();
		}

		if (!Modernizr.touchevents) {
			//smoother.scrollTo(this.hash);
			smoothScrollingTo(this.hash, -80);
		} else {
			smoothScrollingTo(this.hash, 80);
		}

		window.history.pushState({}, "", CURRENT_URL + this.hash);

		if ($('.menu-container').hasClass('show')) {
			let inner = $('.menu-inner');
			$('.menu-container').removeClass('show');
			inner.removeClass('toggle');
			blockScroll(0);
		}
	});

	// BACK TO TOP
	$('.lift').on('click', function (e) {
		e.preventDefault();
		$(window).scrollTop(0);
	})

	// scroll to when entering the page with a hash on the url
	if (!Modernizr.touchevents) {
		setTimeout(() => {
			//smoother.scrollTo(location.hash);
			smoothScrollingTo(location.hash, -80);
		}, 1000);
	} else {
		setTimeout(() => {
			smoothScrollingTo(location.hash, 80);
		}, 1000);
	}

	// home banner typeritter effect
	if ($('.hero-title').length) {
		// Check if have words
		if (heroWords.length) {
			// Split words
			const words = heroWords.split(',');

			gsap.fromTo('.cursor', {
				autoAlpha: 0
			}, {
				autoAlpha: 1,
				duration: 0.5,
				repeat: -1,
				ease: SteppedEase.config(1)
			});

			const tl = gsap.timeline({
				ease: SteppedEase.config(15),
				opacity: 0,
				repeat: -1,
			});

			const defaults = {
				opacity: 1,
				yoyo: true,
				repeat: 1,
				repeatDelay: 2,
				duration: 1
			};

			words.forEach(function (word) {
				tl.add(gsap.to('.typed-text', Object.assign({
					text: word
				}, defaults)));
			});
		}
	}

	// typeritter effect
	if ($('.dynamic-text').length) {
		const new_words = phpString.split(",");

		gsap.fromTo('.cursor2', {
			autoAlpha: 0
		}, {
			autoAlpha: 1,
			duration: 0.5,
			repeat: -1,
			ease: SteppedEase.config(1)
		});


		let tl = gsap.timeline({
			ease: SteppedEase.config(15),
			opacity: 0,
			repeat: -1,
		});

		let textClass = '.dynamic-output';

		let defaults = {
			opacity: 1,
			yoyo: true,
			repeat: 1,
			repeatDelay: 2,
			duration: 1
		};

		new_words.forEach(function (word) {
			tl.add(gsap.to(textClass, Object.assign({
				text: word
			}, defaults)));
		});

	}


	// PIN ELEMENTS
	/* if($('#we_are_pin').length && !Modernizr.touchevents){
		ScrollTrigger.create({
			trigger: "#bridge-ani",
			start: "top top", 
			end: "+=1000",
			pin: "#we_are_pin"
		});
	} */

	if ($('#road_section_pin').length && !Modernizr.touchevents) {
		ScrollTrigger.create({
			trigger: "#road_section_trigger",
			start: "top 100px",
			end: "bottom 150px",
			pin: "#road_section_pin"
		});
	}

	// HIDE CONTACT BUTTON STICKY ON SCROLL BOTTOM
	if ($('.lets-talk-btn').length) {
		let letsTalkTL = gsap.timeline({
			scrollTrigger: {
				trigger: "#footer",
				start: 'top bottom',
				end: "top center",
				scrub: 0,
			},
		});

		letsTalkTL.addLabel("start")
			.to(".lets-talk-btn", { scale: 0, opacity: 0, })
			.addLabel("end");
	}


	//MENU ANIMATION



	/* 
		var lastScrollTop = 0;
		var scrollDirectionChanged = null;
		var dir ;
		
		$(window).scroll(function() {
		  var currentScrollTop = $(this).scrollTop();
		
		  if (currentScrollTop > lastScrollTop && scrollDirectionChanged !== false) {
			scrollDirectionChanged = false;
			console.log("Scrolling downwards");
		  } else if (currentScrollTop < lastScrollTop && scrollDirectionChanged !== true) {
			scrollDirectionChanged = true;
			console.log("Scrolling upwards");
			
		  }
		
		  lastScrollTop = currentScrollTop;
		});
		
		// Usage:
		console.log("Initial scroll direction: " + scrollDirectionChanged); */



	//SLIDER ANIMATIONS




	if ($(".languages-container").length) {
		let $window = $(window);
		let scrollTop = $window.scrollTop();
		let lastScrollTop = 0;
		let scrollDir;
		let scrollDirectionChanged = null;
		let duration = $(".languages-container").attr('data-duration') ? parseInt($(".languages-container").attr('data-duration')) : 0;
		$(".languages-container").find('.languages-wrap').clone().appendTo('.languages-container');

		let proxyTween = gsap.to(".languages-container .languages-wrap", {
			xPercent: 100,
			repeat: -1,
			duration: duration,
			ease: "linear"
		}).totalProgress(0.5);

		$window.on("scroll", function () {
			let currentScrollTop = $(this).scrollTop();

			scrollDir = scrollTop < lastScrollTop;


			if (currentScrollTop > lastScrollTop && scrollDirectionChanged !== false) {
				scrollDirectionChanged = false;
				//console.log("Scrolling downwards");
				proxyTween.reverse();
			} else if (currentScrollTop < lastScrollTop && scrollDirectionChanged !== true) {
				scrollDirectionChanged = true;
				//console.log("Scrolling upwards");
				proxyTween.play();
			}

			lastScrollTop = currentScrollTop;
		});
	}

	if ($(".languages-container2").length) {
		let $window = $(window);
		let scrollTop = $window.scrollTop();
		let lastScrollTop = 0;
		let scrollDir;
		let scrollDirectionChanged = null;
		let duration = $(".languages-container2").attr('data-duration') ? parseInt($(".languages-container2").attr('data-duration')) : 0;
		$(".languages-container2").find('.languages-wrap2').clone().appendTo('.languages-container2');

		let proxyTween2 = gsap.to(".languages-container2 .languages-wrap2", {
			xPercent: 100,
			repeat: -1,
			duration: duration,
			ease: "linear"
		}).totalProgress(0.5);
		proxyTween2.reverse();
		$window.on("scroll", function () {
			let currentScrollTop = $(this).scrollTop();

			scrollDir = scrollTop < lastScrollTop;


			if (currentScrollTop > lastScrollTop && scrollDirectionChanged !== false) {
				scrollDirectionChanged = false;
				//console.log("Scrolling downwards");
				proxyTween2.play();
			} else if (currentScrollTop < lastScrollTop && scrollDirectionChanged !== true) {
				scrollDirectionChanged = true;
				//console.log("Scrolling upwards");

				proxyTween2.reverse();
			}

			lastScrollTop = currentScrollTop;
		});
	}



	if ($('.rotary-words-banner').length) {

		$(".rotary-words-banner")
			.find('.words-wrap')
			.clone()
			.appendTo('.rotary-words-banner');

		let proxyTween = gsap.to(".rotary-words-banner .words-wrap", {
			xPercent: -100,
			repeat: -1,
			duration: 25,
			ease: "linear"
		}).totalProgress(0.5);

	}



	if ($('.loading-text').length) {
		//"Design", "Strategy", 
		const words = ["hello"];

		gsap.fromTo('.cursor3', {
			autoAlpha: 0
		}, {
			autoAlpha: 1,
			duration: 0.5,
			repeat: -1,
			ease: SteppedEase.config(1)
		});


		let tl = gsap.timeline({
			ease: SteppedEase.config(15),
			opacity: 0,
			repeat: 0,
		});

		let textClass = '.loading-text';

		let defaults = {
			opacity: 1,
			yoyo: true,
			repeat: 0,
			repeatDelay: 2,
			duration: 1
		};

		words.forEach(function (word) {
			tl.add(gsap.to(textClass, Object.assign({
				text: word
			}, defaults)));
		});
	}

	gsap.set(".ball", {
		xPercent: -50,
		yPercent: -50
	});

	const ball = $(".ball");
	const pos = {
		x: $(window).width() / 2,
		y: $(window).height() / 2
	};
	const mouse = {
		x: pos.x,
		y: pos.y
	};
	const speed = 0.35;

	const xSet = gsap.quickSetter(ball, "x", "px");
	const ySet = gsap.quickSetter(ball, "y", "px");

	$(window).on("mousemove", e => {
		mouse.x = e.clientX;
		mouse.y = e.clientY;

		if (ball[0].style.opacity < 0.9) {
			gsap.to(ball, {
				duration: 0.7,
				ease: 'power4',
				opacity: 1
			});
		}
	});

	gsap.ticker.add(() => {
		const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());

		pos.x += (mouse.x - pos.x) * dt;
		pos.y += (mouse.y - pos.y) * dt;
		xSet(pos.x);
		ySet(pos.y);
	});

	document.addEventListener('mouseleave', (e) => {
		gsap.to(ball, {
			duration: 0.7,
			opacity: 0,
		});
	});

	// special thanks to Blake Bowen for most of the code.

	$(".trigger-zone").each(function () {
		// let tl = gsap.timeline({
		// 	ease: SteppedEase.config(15),
		// 	opacity: 0,
		// 	repeat: 0,
		// });
		$(this).on("mouseenter", function () {
			gsap.killTweensOf(".ball");
			var text = $(this).attr("data-text");
			$('.ball .ball-text').html('<span class="inner-text">' + $(this).attr("data-text") + '</span>').find('.inner-text').animate({
				opacity: 1
			}, 1000);
			$('.ball').addClass('show');

			gsap.to(ball, {
				scale: 1.5,
				duration: 0.25
			});

			// tl.restart();
			// //const words = ["Transformation"];

			// let textClass = '.ball';

			// let defaults = {
			// 	opacity: 1,
			// 	yoyo: false,
			// 	repeat: 1,
			// 	repeatDelay: 2,
			// 	duration: 1
			// };
			// tl.add(gsap.to(textClass, Object.assign({ text: text }, defaults)));

		});

		$(this).on("mouseleave", function () {

			gsap.to(ball, {
				scale: 1
			});

			// tl.pause();
			$('.ball .ball-text').html('');
			$('.ball').removeClass('show');
		});
	});

	$(".accordion-title").on('click', function () {
		$(this).toggleClass("is-open").find(".accordion-desc").slideToggle();
	});



	/* OFFERS DROP-DOWN */
	// if($('#accordion').length){
	// 		if(!window.location.hash){
	// 			$("#accordion-span-default").addClass('down');
	// 			$("#accordion-desc-default").show();
	// 		}
	// 		$('#accordion').find('.accordion-visible-block').on('click', function(){

	// 			if($(this).hasClass('is-open').length){
	// 				$(this).parents('.accordion-title').removeClass('is-open');
	// 				$(this).parents('.accordion-title').find('.accordion-desc').slideUp(200);
	// 				$.bbq.pushState("#close");
	// 			}else{
	// 				$.bbq.pushState("#" + $(this).attr("data-url"));
	// 			}
	// 			});

	// 		$(window).bind("hashchange", function(event){

	// 			var $target = $('#accordion-' + decodeURIComponent($.param.fragment()));

	// 			if($target.length){
	// 				$target.find('.accordion-desc').slideToggle(200, function(){
	// 					$("body, html").stop().delay(100).animate({scrollTop: ($target.offset().top - 120)}, 400);
	// 				});
	// 				$('.accordion-title').not($target).removeClass('is-open');
	// 				$target.toggleClass('is-open');
	// 				var thisspan = $target.find('span');
	// 				$(".accordion-desc:visible").not($target.find('.accordion-desc')).slideUp(200);
	// 			}

	// 		}).trigger("hashchange");
	// 	}

	// const accSingleTriggers = document.querySelectorAll('.accordion-visible-block');

	// accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));

	// function toggleAccordion() {
	// 	const items = document.querySelectorAll('.accordion-title');
	// 	const thisItem = this.parentNode;

	// 	items.forEach(item => {
	// 		if (thisItem == item) {
	// 			thisItem.classList.toggle('is-open');
	// 			return;
	// 		}
	// 		item.classList.remove('is-open');
	// 	});
	// }



	//SCRAMBLE TEXT
	const chars = "abcdefghijklmnopqrstuvwxyz0123456789*-+/=:";
	// $('#menu-toggle').on('mouseenter', function (e) {
	// 	var el = $(this);
	// 	if (!el.hasClass("menu-toggle-animate") && !$("html").hasClass("touchevents")) {
	// 		el.addClass("menu-toggle-animate");
	// 		gsap.to($(this),
	// 			{
	// 				duration: 0.7,
	// 				scrambleText:
	// 				{
	// 					text: $(this).text(),
	// 					chars: chars,
	// 					revealDelay: 0.3,
	// 					speed: 0.3
	// 				},
	// 				onComplete: function () {
	// 					el.removeClass("menu-toggle-animate");
	// 				}
	// 			});
	// 	}
	// });

	$('.matrix-letters > a > span').on('mouseenter', function (e) {
		var el = $(this);
		if (!el.hasClass("menu-item-animate") && !$("html").hasClass("touchevents")) {
			el.addClass("menu-item-animate");
			gsap.to($(this), {
				duration: 0.7,
				scrambleText: {
					text: $(this).text(),
					chars: chars,
					// revealDelay: 0.3,
					speed: 0.3
				},
				onComplete: function () {
					el.removeClass("menu-item-animate");
				}
			});
		}
	});

	//MENU
	const currentUrl = window.location.href;

	if (currentUrl == "http://localhost:3000/velcrodev.com/public/en/join-us" || currentUrl == "https://www.velcrodev.com/en/join-us") {
		$('.matrix-letters > a').on('click', function () {
			var teste = $(this).attr("href");
			window.history.pushState("", "", "en");
			location.reload();
		});
	}

	//SCROLL SECTION SERVICES

	gsap.registerPlugin(ScrollTrigger);

	const sections = gsap.utils.toArray(".block-inner-container");

	if (document.getElementById("road-container-js")) {
		const cont = document.querySelector("#road-container-js");
		const anim = gsap.to(sections, {
			x: () => -1 * (cont.scrollWidth - innerWidth),
			ease: "none",
			scrollTrigger: {
				trigger: ".road-container",
				pin: true,
				scrub: 1,
				onEnter: () => $('.dots').find('.checkmark').addClass('start'),
				// base vertical scrolling on how wide the container is so it feels more natural.
				end: () => "+=" + (cont.scrollWidth - innerWidth),
			}
		});

		// if (window.innerWidth > 992) {
		// 	const anim = gsap.to(sections, {
		// 		x: () => -1 * (cont.scrollWidth - innerWidth),
		// 		ease: "none",
		// 		scrollTrigger: {
		// 			trigger: ".road-container",
		// 			pin: true,
		// 			scrub: 1,
		// 			onEnter: () => $('.dots').find('.checkmark').addClass('start'),
		// 			// base vertical scrolling on how wide the container is so it feels more natural.
		// 			end: () => "+=" + (cont.scrollWidth - innerWidth),
		// 		}
		// 	});
		// 	// const auto = gsap.timeline({ repeat: -1 })
		// 	// 	.to(anim, {
		// 	// 		duration: 5,
		// 	// 		progress: 0,
		// 	// 		ease: "none",
		// 	// 	});
		// 	// window.addEventListener("scroll", () => auto.kill());
		// } else if (window.innerWidth < 450) {

		// 	/* window.addEventListener("scroll", () => auto.kill()); */
		// } else {

		// 	const anim = gsap.to(sections, {
		// 		xPercent: -90 * (sections.length - 1),
		// 		ease: "none",
		// 		scrollTrigger: {
		// 			trigger: ".road-container",
		// 			pin: true,
		// 			scrub: 1,
		// 			// base vertical scrolling on how wide the container is so it feels more natural.
		// 			end: () => "+=" + document.getElementById("road-container-js").offsetWidth,
		// 		}
		// 	});
		// 	const auto = gsap.timeline({ repeat: -1 })
		// 		.to(anim, {
		// 			duration: 5,
		// 			progress: 0,
		// 			ease: "none",
		// 		});
		// 	window.addEventListener("scroll", () => auto.kill());
		// }
		/* 	const auto = gsap.timeline({ repeat: -1 })
			.to(anim, {
				duration: 5,
				progress: 0,
				ease: "none",
			});
	 */
		/* window.addEventListener("scroll", () => auto.kill()); */
	}

	// function tilt(cx, cy) {
	// 	// var sxPos = cx / $panel.width() * 100 - 100;
	// 	// var syPos = cy / $panel.height() * 100 - 100;
	// 	var sxPos = (cx / $body.width()*100 - 50)*2 ;
	// 	var syPos = (cy / $body.height()*100 - 50)*2;
	// 	TweenMax.to($pContent, 2, {
	// 		rotationY: -0.03 * sxPos,
	// 		rotationX: 0.03 * syPos,
	// 		transformPerspective: 500,
	// 		transformOrigin: "center center -400",
	// 		ease: Expo.easeOut
	// 	});
	// 	TweenMax.to($img, 2, {
	// 		rotationY: -0.03 * sxPos,
	// 		rotationX: 0.03 * syPos,
	// 		transformPerspective: 500,
	// 		transformOrigin: "center center -200",
	// 		ease: Expo.easeOut
	// 	});
	// }

	$('.abs-positioning').tilt({
		maxTilt: 10
	});



	//gsap.to($targetDiv, {duration: 1, scrambleText: {text: "THIS IS NEW TEXT", chars: "XO", revealDelay: 0.5, speed: 0.3, newClass: "myClass"}});


	/* gsap.to('.section-services', { 
		scrollTrigger: {
			//anticipatePin: 1,
		  trigger: '.section-services',
		  pin: true,
		  end: 'bottom center',
		  start: 'top top+=30',
		  markers: true
		}
	  }); */

	/*  gsap.utils.toArray('.card-inner').forEach((box, i) => {
	   gsap.fromTo(box, {
		   autoAlpha: 0, 
		   y: 50
		 }, {
		 scrollTrigger: {
		   trigger: '.section-services',
	   	
		   scrub: true,
		   start: 'top center',
		   markers: true
		 },
		 duration: 1, 
		 delay: i * 0.5,
		 autoAlpha: 1, 
		 y: 0
	   });
	 }); */
	/*   gsap.fromTo('.card-inner', {
		autoAlpha: 0, 
		y: 150
	  }, {
	  scrollTrigger: {
		trigger: '.section-services',
		start: 'top center+=300',
		scrub: true,
		markers: true
	  },
	  duration: 0.5, 
	  autoAlpha: 1, 
	  stagger: 0.15,
	  y: 0
	}); */

	//LOTTIE ANIMATION


	$('#menu-toggle').on('click', function (e) {

		let inner = $('.menu-inner');
		if (!inner.hasClass('toggle')) {
			$('.menu-container').addClass('show');
			inner.addClass('toggle');
			blockScroll(1);

			setTimeout(function () {

				$('.nav li').each(function (i) {
					var el = $(this);
					setTimeout(function () {
						el.addClass('show');
						if (el.hasClass('last')) {
							// $('#networks').addClass('show');
							$('.menu-lang-container').addClass('show');
							$('.menu-info').addClass('show');
							$('.menu-networks').addClass('show');
						}
					}, (i + 1) * 50);
				});
			}, 200);

		} else {

			$('.menu-container').removeClass('show');
			inner.removeClass('toggle');
			$('.nav li').each(function (i) {
				var el = $(this);
				el.removeClass('show');
			});
			$('.menu-lang-container').removeClass('show');
			$('.menu-info').removeClass('show');
			$('.menu-networks').removeClass('show');
			blockScroll(0);
		}
	})

	$('li.close-menu').on('click', function () {
		$('.menu-container').removeClass('show');
		$('.menu-inner').removeClass('toggle');
	});

	/**
	 * Exemplo de submissão de form
	 */
	$('body').on('click', '#send-suggestion', function (e) {
		e.preventDefault();

		var form = $('form.suggestion-form');
		var fields = form.serialize();
		var action = form.attr('action');

		if (checkPolicy(form)) {
			var send = true;
			form.find('#feedback__suggestion').removeClass().html('');
			form.find('.invalid').removeClass('invalid');

			if ($('#email').length) {
				var email = $('#email').val();
				if (!IsEmail(email)) {
					form.find('#email').parent().addClass('invalid');
					form.find('#feedback__suggestion').removeClass().html(LANG.email_invalido).addClass('error').fadeIn("fast");
					send = false;
				}
			}

			var required = form.find('.required');
			required.each(function () {
				if ($.trim($(this).val()) == '' || $.trim($(this).val()) == $(this)[0].defaultValue) {
					$(this).parent().addClass('invalid');
					form.find('#feedback__suggestion').removeClass().html(LANG.preencha_os_campos_em_falta).addClass('error').fadeIn("fast");
					send = false;
				}
			});
			if (send) {
				$.blockUI();
				$.ajax({
					url: action,
					type: 'POST',
					data: fields,
					dataType: 'json',
					success: function (r) {
						if (r.class == 'ok') {
							form[0].reset();
						}
						$('#feedback__suggestion').show().addClass(r.class).html(r.message);
						$.unblockUI();
					},
					error: function (r) {
						$('#feedback__suggestion').show().addClass('error').html(LANG.email_erro);
						$.unblockUI();
					}
				});
			}
		} else {
			$('#feedback__suggestion').show().addClass('error').html(LANG.accept_privacy_policy);
			$.unblockUI();
		}
	});

	if (!Modernizr.objectfit) {
		$('body .objectfit').each(function () {
			var $container = $(this),
				imgUrl = $container.find('img').prop('src');
			if (imgUrl) {
				$container
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}

	/**
	 * Init jobs offers cards.
	 */
	if ($('.job-offer-card').length) {
		// Header toggle
		$('body').on('click', '.job-offer-card .job-offer-card__header', function (e) {
			e.preventDefault();
			e.stopPropagation();

			$(this).parent('.job-offer-card ').toggleClass('expanded').find('.job-offer-card__content').slideToggle();
		});
	}

	var swiper1 = new Swiper(".single-slider", {
		effect: "fade",
		autoplay: {
			delay: 4000,
		},
		fadeEffect: { // Add this
			crossFade: true,
		},
		allowTouchMove: false,
		pagination: {
		},
	});
	var swiper2 = new Swiper(".people-slider", {
		allowTouchMove: false,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {

		},
	});

});

/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
	if (block == 1) {
		$('html').addClass('block-scroll');
	} else if (block == 0) {
		$('html').removeClass('block-scroll');
	}
}